import { Link } from 'react-router-dom';
import { useSidebar } from '@strivelabs/ui-blocks/v2';
import { APP_ROUTES } from '@/constants';
import { useCurrentTheme } from '@/hooks/useTheme';

/**
 * The logo and wordmark, linking home.
 *
 * Both come from the active theme so white-label brands render their own name
 * and mark rather than Strive's. Labelled with the brand name rather than "Home"
 * so it does not collide with the Home nav item — two links sharing one
 * accessible name is ambiguous to a screen reader. The wordmark is dropped in
 * the rail, where 52px leaves no room for it.
 */
export function SidebarBrand() {
  const { name, assets } = useCurrentTheme();
  const { collapsed } = useSidebar();

  return (
    <Link
      to={APP_ROUTES.HOME}
      aria-label={name}
      className="flex min-w-0 items-center gap-2 rounded-v2-md px-1 py-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-v2-sidebar-ring"
    >
      <img src={assets.navbarLogo} alt="" className="size-5 shrink-0 object-contain" />
      {collapsed ? null : (
        <span className="truncate text-v2-lg font-semibold text-v2-sidebar-foreground">
          {name}
        </span>
      )}
    </Link>
  );
}
